export const tr = {
    confirm:
        'Netleştirme kalıcı olarak silinerek eklendiği tüm reklamlardan kaldırılacak. Netleştirmeyi sadece bu reklamdan kaldırmak için sağdaki listeden silin.',
    title: 'Netleştirmeyi silmek istediğinize emin misiniz?'
};
